var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.28961 9.70326L2.18233 11.1841L3.45355 6.02065L5.03936 7.54303L7.5974 4.87841C7.68424 4.78795 7.80422 4.73681 7.92961 4.73681C8.05501 4.73681 8.17498 4.78795 8.26183 4.87841L10.1401 6.83495L12.9026 3.95737C13.0787 3.77389 13.3702 3.76794 13.5537 3.94408C13.7372 4.12022 13.7431 4.41174 13.567 4.59522L10.4723 7.81885C10.3855 7.90931 10.2655 7.96045 10.1401 7.96045C10.0147 7.96045 9.89473 7.90931 9.80789 7.81885L7.92961 5.86231L5.70379 8.18088L7.28961 9.70326Z",
    fill: "#FF3C11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.b575df91e93a84504d2b75ed21c16f9d.svg";
export { ForwardRef as ReactComponent };